export default "__VITE_ASSET__cc0b6460__"